module.exports = __webpack_public_path__ + "static/5ed770cf27e975bca050abfc74fe9c52503edc29d3514dbaccab6f0c91804a7d-d274dabcd78bb2b263c4da9e32b3d069.png";